var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 6.41667V4.66667C9.91667 3.05584 8.61083 1.75 7 1.75C5.38917 1.75 4.08333 3.05584 4.08333 4.66667V6.41667M4.55 12.25H9.45C10.4301 12.25 10.9201 12.25 11.2945 12.0593C11.6238 11.8915 11.8915 11.6238 12.0593 11.2945C12.25 10.9201 12.25 10.4301 12.25 9.45V9.21667C12.25 8.23657 12.25 7.74653 12.0593 7.37218C11.8915 7.0429 11.6238 6.77518 11.2945 6.60741C10.9201 6.41667 10.4301 6.41667 9.45 6.41667H4.55C3.56991 6.41667 3.07986 6.41667 2.70552 6.60741C2.37623 6.77518 2.10852 7.0429 1.94074 7.37218C1.75 7.74653 1.75 8.23657 1.75 9.21667V9.45C1.75 10.4301 1.75 10.9201 1.94074 11.2945C2.10852 11.6238 2.37623 11.8915 2.70552 12.0593C3.07986 12.25 3.56991 12.25 4.55 12.25Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0c7afe622c0610170d16d3e69bfb2410.svg";
export { ForwardRef as ReactComponent };